import { PropsWithChildren } from 'react';
import {
  AppointmentTypeGroup,
  BookableAppointmentTypeBulkUpdate,
} from '@weave/schema-gen-ts/dist/schemas/schedule/v3/bookable_appointment_type.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { Modal, ModalControlModalProps, MoneyField, useAlert, useFormField } from '@frontend/design-system';

export const SamePrepayAmountUpdate = ({
  appointmentTypeGroups,
  locationId,
  modalProps,
  children,
}: PropsWithChildren<{
  appointmentTypeGroups: AppointmentTypeGroup[];
  locationId: string;
  modalProps: ModalControlModalProps;
}>) => {
  const { t } = useTranslation('scheduleServiceTypes');
  const alerts = useAlert();

  const sameAmountFieldProps = useFormField({ type: 'money', value: '', required: true });

  const { mutateAsync } = SchedulerV3.Mutations.useBulkUpdateBookableAppointmentTypesMutation();
  const handleUpdateAmounts = async () => {
    try {
      if (!sameAmountFieldProps.value) {
        return;
      }
      await mutateAsync({
        updateType: 'PREPAYMENT_AMOUNT',
        locationId,
        updates: appointmentTypeGroups.reduce((acc, at) => {
          const bookableAppointmentType = at.bookableAppointmentTypes?.[0];
          if (bookableAppointmentType) {
            acc.push({
              bookableAppointmentTypeId: bookableAppointmentType.id,
              prepaymentAmount: Number(sameAmountFieldProps.value || 0) * 100,
            });
          }
          return acc;
        }, [] as BookableAppointmentTypeBulkUpdate[]),
      });

      modalProps.onClose();
    } catch (error) {
      alerts.error(t('Failed to update pre-pay amounts'));
    }
  };

  return (
    <>
      <Modal.Body>
        {children}
        <MoneyField name='same-prepay-amount' label={t('Amount')} placeholder='$' {...sameAmountFieldProps} />
      </Modal.Body>
      <Modal.Footer
        primary={{
          disabled: !sameAmountFieldProps.value,
          label: t('Apply Assignments'),
          onClick: handleUpdateAmounts,
        }}
        secondary={{
          label: t('Cancel'),
          onClick: () => modalProps.onClose(),
        }}
      />
    </>
  );
};
